import React from 'react';

/**
 * SplashBI Logo Component
 * Displays the company logo with configurable size
 *
 * @param {Object} props
 * @param {string} props.className - CSS classes for styling (including height)
 */
const SplashBILogo = ({ className = "h-8" }) => (
  <img
    src="/SplashBI-logo.svg"
    alt="SplashBI"
    className={`object-contain ${className}`}
  />
);

export default SplashBILogo;
